import React from "react";

export const Svg = ({ id }) => {
  if (!id) return null;
  const entities = {
    add: (
      <svg className="add" version="1.1" x="0" y="0" viewBox="0 0 14 14">
        <polygon points="0.5,5.4 5.6,5.4 5.6,0.5 8.5,0.5 8.5,5.4 13.6,5.4 13.6,8.5 8.7,8.5 8.6,13.5 5.7,13.5 5.7,8.5 0.5,8.5 " />
      </svg>
    ),
    del: (
      <svg className="del" version="1.1" x="0" y="0" viewBox="0 0 13 15">
        <g>
          <polyline points="0,2.5 4.5,2.5 13,2.5" />
          <rect x="4.5" y="0.5" width="3.9" height="2" />
          <line x1="1.5" y1="14" x2="1.5" y2="3" />
          <line x1="11.5" y1="14" x2="11.5" y2="3" />
          <line x1="6.5" y1="13" x2="6.5" y2="4" />
          <line x1="8.5" y1="13" x2="8.5" y2="4" />
          <line x1="4.5" y1="13" x2="4.5" y2="4" />
          <line x1="11" y1="14.5" x2="2" y2="14.5" />
        </g>
      </svg>
    ),
    edit: (
      <svg className="edit" version="1.1" x="0" y="0" viewBox="0 0 14 14">
        <polygon points="0,14 0,10.6 8.4,2.2 11.9,5.6 3.5,14 " />
        <polygon points="12.6,4.9 14,3.5 14,2.5 11.6,0 10.5,0 9.1,1.4 " />
      </svg>
    ),
    bar: (
      <svg className="line" version="1.1" x="0" y="0" viewBox="0 0 18 18">
        <polyline points="0.5,2 0.5,17.5 18,17.5" />
        <line x1="2.9" y1="10" x2="2.9" y2="16" />
        <line x1="5.9" y1="3" x2="5.9" y2="16" />
        <line x1="8.9" y1="7" x2="8.9" y2="16" />
        <line x1="11.9" y1="5" x2="11.9" y2="16" />
        <line x1="15.1" y1="11.2" x2="15.1" y2="16" />
      </svg>
    ),
    line: (
      <svg className="bar" version="1.1" x="0" y="0" viewBox="0 0 18 18">
        <polyline points="0.5,2 0.5,17.5 18,17.5" />
        <polyline points="2,10 7,5 13,10 16,7" />
      </svg>
    ),
    percent: (
      <svg className="percent" version="1.1" x="0" y="0" viewBox="0 0 18 18">
        <line x1="5" y1="14" x2="14" y2="5" />
        <path d="M13,11c2.6,0,2.6,5.1,0,5.1S10.5,11,13,11z" />
        <path d="M5.5,3.9c2.6,0,2.6,5.1,0,5.1S3,3.9,5.5,3.9z" />
      </svg>
    ),
    copy: (
      <svg className="copy" version="1.1" x="0" y="0" viewBox="0 0 13 15">
        <path className="st1" d="M2.3,14.6H11c0.9,0,1.5-0.6,1.5-1.5V3.5l-0.7,0.6v8.5c0,0.8-0.5,1.3-1.3,1.3H3L2.3,14.6z"/>
        <path className="st2" d="M0.5,11.5h7.8c0.8,0,1.3-0.6,1.3-1.5V0.5h-3V5c0,0.4-0.3,0.7-0.9,0.7H0.5L0.5,11.5z"/>
        <path className="st2" d="M4.1,1.1v1.7C4.1,3,4,3.1,3.8,3.1H2.2L4.1,1.1z"/>
      </svg>
    ),
    pie: (
      <svg className="pie" viewBox="0 0 1792 1792">
        <path d="M768 890l546 546q-106 108-247.5 168t-298.5 60q-209 0-385.5-103t-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103v762zm187 6h773q0 157-60 298.5t-168 247.5zm709-128h-768v-768q209 0 385.5 103t279.5 279.5 103 385.5z" />
      </svg>
    )
  };
  return <div>{entities[id]}</div>;
};



// WEBPACK FOOTER //
// ./src/components/utils/Svg.js